import { useEffect, useState } from "react";
import styles from "./navbar-mobile.module.css";
import { useRouter } from "next/router";

export function NavBarMobile() {
	const [showMenu, setShowMenu] = useState(false);
	const router = useRouter();

	useEffect(() => {
		if (showMenu && typeof window !== 'undefined') {
			document.body.style.overflow = 'hidden'; // Disable scrolling when menu is open
		} else {
			document.body.style.overflow = 'auto'; // Enable scrolling when menu is closed
		}		
	}, [showMenu]);
	useEffect(() => {
		setShowMenu(false);
	}, [router.pathname]);
  return (
    <div className="showInMobile">
      <div
        className={styles.mobileNavContainer}
        style={{ display: `${showMenu ? "block" : "none"}` }}
      >
        <nav className={styles.navbar}>
          <div className={styles.navbarHeader}>Løping</div>
          <ul>
            <li><a href="/sok?q=Løpesko herre">Sko herre</a></li>
            <li><a href="/sok?q=Løpesko dame">Sko dame</a></li>
            <li><a href="/sok?q=Løpesko junior">Sko junior</a></li>
            <li><a href="/sok?q=Løpesko terreng">Sko terrengløp</a></li>
            <li><a href="/sok?q=Løpesko asfalt">Sko asfalt</a></li>
            <li><a href="/sok?q=Løpejakke">Løpejakke</a></li>
            <li><a href="/sok?q=Løpebukse">Løpebukse</a></li>
            <li><a href="/sok?q=Mellomlag løping">Mellomlag løping</a></li>
          </ul>

          <div className={styles.navbarHeader}>Sykkel</div>
          <ul>
            <li><a href="/sok?q=Elsykkel">Elsykkel</a></li>
            <li><a href="/sok?q=Lastesykkel">Lastesykkel</a></li>
            <li><a href="/sok?q=Hardtail">Hardtail</a></li>
            <li><a href="/sok?q=Gravel">Gravelsykkel</a></li>
            <li><a href="/sok?q=Pedaler">Pedaler</a></li>
            <li><a href="/sok?q=Sykkelsko">Sykkelsko</a></li>
            <li><a href="/sok?q=Mekkestativ">Mekkestativ</a></li>
            <li><a href="/sok?q=Sykkel pumpe">Pumper</a></li>
            <li><a href="/sok?q=Demper">Demper</a></li>
            <li><a href="/sok?q=Sykkelcomputer">Sykkelcomputer</a></li>
            <li><a href="/sok?q=Sykkelvesker">Sykkelvesker</a></li>
            <li><a href="/sok?q=Sykkelstativ">Sykkelstativ</a></li>
          </ul>

          <div className={styles.navbarHeader}>Vannsport</div>
          <ul>
            <li><a href="/sok?q=SUP brett">Paddleboard</a></li>
            <li><a href="/sok?q=Dykkerutstyr">Dykkerutstyr</a></li>
          </ul>

          <div className={styles.navbarHeader}>Trening</div>
          <ul>
            <li><a href="/sok?q=Protein">Protein</a></li>
            <li><a href="/sok?q=Ryggsekk">Ryggsekk</a></li>
            <li><a href="/sok?q=Pulsmåler">Pulsmåler</a></li>
            <li><a href="/sok?q=Garmin">Garmin</a></li>
          </ul>

          <div className={styles.navbarHeader}>Tur & Friluft</div>
          <ul>
            <li><a href="/sok?q=Tursko">Tursko</a></li>
            <li><a href="/sok?q=Jakker">Jakker</a></li>
            <li><a href="/sok?q=Regntøy">Regntøy</a></li>
            <li><a href="/sok?q=Skalljakker">Skalljakker</a></li>
          </ul>

          <div className={styles.navbarHeader}>Tilbehør</div>
          <ul>
            <li><a href="/sok?q=Vannflasker">Vannflasker</a></li>
            <li><a href="/sok?q=Luer">Luer</a></li>
            <li><a href="/sok?q=Hansker">Hansker</a></li>
            <li><a href="/sok?q=Solbriller">Solbriller</a></li>
          </ul>

        </nav>
      </div>
      <button
        className={styles.fab}
        onClick={() => {
          setShowMenu(!showMenu);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
        >
          <title>menu</title>
          {!showMenu ? (
            <path
              fill="#fff"
              d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
            />
          ) : (
            <path
              fill="#fff"
              d="M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z"
            />
          )}
        </svg>
      </button>
    </div>
  );
}
